<template>
  <!--{'pt-100':$route.path.indexOf('opt5') >= 0, 'pt-210': $route.path.indexOf('opt6') >=0, 'pt-250': $route.path.indexOf('opt2') >=0, 'pt-120': $route.path.indexOf('opt') < 0}-->
  <div id="cpn-home-popular">
    <!--<span>{{$t('home.button_our_most_popular_deals')}}</span>-->
    <!--<h2 class="cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr"></h2>-->

    <div class="home-bottom xs-mb-0 xs-position-relative">
      <!-- <a :href="$const.URL_TOPIC_OKIPIZZA_2"><img :src="$const.IMAGES.HOME_CARD_CORONA_2" class="img-card pt10 pl10 pr10" /></a> -->
      <a :href="topImage.url || 'javascript:void(0)'"><img v-bind:src="isMobile() ? topImage.image.mobile : topImage.image.desktop" class="img-card pt10 pl10 pr10" /></a>
      <a :href="hutReward.url || 'javascript:void(0)'"><img v-bind:src="isMobile() ? hutReward.image.mobile : hutReward.image.desktop" class="img-card p10" /></a>
      <div id="bannerMidBottom" class="h-110 m-10 imgLoadingTopHome" style="width: 576px;"></div>
    </div>
    <div class="md-flex md-justify-center md-pb-10 lg-container banner-home">
      <div id="leftHomeBanner" class="h-185 m-10 imgLoadingTopHome" style="width: 520px;"></div>
      <a href="javascript: void(0)" @click="handleClickItem('left', left.url)"
         v-if="left && left.image.desktop"
         class="xs-block p10 xs-pb-0 xs-pt-5 decoration-none xs-full-width" data-synth="first-deal">
        <img v-bind:src="isMobile() ? left.image.mobile : left.image.desktop"
             data-synth="home-promo--5-favourite-single-5" class="xs-block xs-full-width" alt="">
        <button v-if="orderNow"
                class="order-now">
          {{ $t('order_now') }}
        </button>
        <div class="xs-text-center xs-text-gray-lightest xs-fill-gray-darkest xs-opacity-90 typo-l8"></div>
        <h2 style="display: none; font-size: 0">{{$t('content.h3.home.campaign1')}} </h2>
      </a>
      <a href="javascript: void(0)" @click="handleClickItem('right', right.url)"
         v-if="right && right.image.desktop"
         class="xs-block p10 xs-pb-0 decoration-none xs-full-width" data-synth="first-deal">

        <img v-bind:src="isMobile() ? right.image.mobile : right.image.desktop"
             data-synth="home-promo--5-favourite-single-5" class="xs-block xs-full-width" alt="">
        <button v-if="orderNow"
                class="order-now">
          {{ $t('order_now') }}
        </button>
        <div class="xs-text-center xs-text-gray-lightest xs-fill-gray-darkest xs-opacity-90 typo-l8"></div>
        <h2 style="display: none; font-size: 0">{{$t('content.h3.home.campaign2')}} </h2>
      </a>
      <div id="rightHomeBanner" class="h-185 m-10 imgLoadingTopHome" style="width: 520px;"></div>
    </div>
    <div class="xs-px-10 xs-mb-40 lg-container">
      <!-- <h2 class="p-0 m-0"><a href="javascript: void(0)" v-on:click.stop="handleClickItem('bottom')"
         class="btn btn--primary btn--xlg w-full pt-15 xs-mb-20" id="btn-view-all-deal-element"
         data-synth="home-link--moredeals"
      >{{ $t('home.button_view_all_deal')}}</a></h2> -->
      <div class="home-bottom">
        <div class="home-description">
          <div class="mb-10" v-html="getTextInErrorMessage($const.CODE_GREEN_CHILLI)"></div>
          <div v-html="getTextInErrorMessage($const.CODE_PONTA_MESSAGE)"></div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

export default {
  props: ['orderNow'],
  computed: {
    ...mapGetters({
      categoryList: 'categoryList'
    })
  },
  mounted() {
    let vm = this
    setTimeout(() => {
      vm.getBanners()
    }, 500)
  },
  data() {
    return {
      hasDisposition: this.checkPosition(this),
      left: {
        image: {
          desktop: '',
          mobile: ''
        },
        url: ''
      },
      right: {
        url: '',
        image: {
          desktop: '',
          mobile: ''
        }
      },
      hutReward: {
        url: '',
        image: {
          desktop: '',
          mobile: ''
        }
      },
      topImage: {
        url: '',
        image: {
          desktop: '',
          mobile: ''
        }
      }
    }
  },
  methods: {
    handleClickItem(type, url) {
      let data = {
        id: 'pop-home',
        moduleId: ''
      }
      if (type == 'bottom') {
        data.id = 'all-home'
        data.moduleId = 'all-home-1'
        this.eventTrackingModuleItemClick(data)
      } else {
        if (type == 'left') {
          data.moduleId = this.left.name.split(' ').join('-')
        } else if (type == 'right') {
          data.moduleId = this.right.name.split(' ').join('-')
        }
        this.eventTrackingModuleItemClick(data)
      }

      if (url) {
        this.redirectToUrl(url, true)
      } else {
        this.redirectToPage(this.$const.SLUG_LIST.DEAL)
      }
    },
    getBanners() {
      var vm = this
      let topHeader = document.getElementById('banner')
      let topMobileHeader = document.getElementById('header-mobile')
      let leftHomeBanner = document.getElementById('leftHomeBanner')
      let rightHomeBanner = document.getElementById('rightHomeBanner')
      let bannerMidBottom = document.getElementById('bannerMidBottom')

      this.axios.apiBanners.getBannersByPosition('?code=right_home,left_home,top_home_web,dine_in_restaurant,dine_in_restaurant_1', respone => {
        let data = respone.data.data.item
        if (this.empty(data)) {
          topHeader.classList.remove('imgLoadingTopHome', 'h-400')
          topMobileHeader.classList.remove('imgLoadingTopHome', 'h-230')
          leftHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          leftHomeBanner.style.width = '0px'
          rightHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          rightHomeBanner.style.width = '0px'
          bannerMidBottom.classList.remove('imgLoadingTopHome', 'h-110')
          return
        }
        let left_image = data.left_home
        let right_image = data.right_home
        let hutReward = data.dine_in_restaurant
        let topImage = data.dine_in_restaurant_1
        let top_home_web = data.top_home_web
        if (typeof left_image !== 'undefined') {
          leftHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          leftHomeBanner.style.width = '0px'
          vm.left.image.desktop = left_image[0].image.desktop
          vm.left.image.mobile = left_image[0].image.mobile
          vm.left.url = left_image[0].url.desktop
          vm.left.name = typeof left_image[0].name == 'string' ? left_image[0].name : left_image[0].name[vm.$session.get('lang')]
        } else {
          leftHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          leftHomeBanner.style.width = '0px'
        }
        if (typeof right_image !== 'undefined') {
          rightHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          rightHomeBanner.style.width = '0px'
          vm.right.image.desktop = right_image[0].image.desktop
          vm.right.image.mobile = right_image[0].image.mobile
          vm.right.url = right_image[0].url.desktop
          vm.right.name = typeof right_image[0].name == 'string' ? right_image[0].name : right_image[0].name[vm.$session.get('lang')]
        } else {
          rightHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
          rightHomeBanner.style.width = '0px'
        }
        if (typeof hutReward !== 'undefined') {
          bannerMidBottom.classList.remove('imgLoadingTopHome', 'h-110')
          vm.hutReward.image.desktop = hutReward[0].image.desktop
          vm.hutReward.image.mobile = hutReward[0].image.mobile
          vm.hutReward.url = hutReward[0].url.desktop
          vm.hutReward.name = typeof hutReward[0].name == 'string' ? hutReward[0].name : hutReward[0].name[vm.$session.get('lang')]
        } else {
          bannerMidBottom.classList.remove('imgLoadingTopHome', 'h-110')
        }

        if (topImage && topImage[0]) {
          vm.topImage.image.desktop = topImage[0].image.desktop
          vm.topImage.image.mobile = topImage[0].image.mobile
          vm.topImage.url = topImage[0].url.desktop
          vm.topImage.name = typeof topImage[0].name == 'string' ? topImage[0].name : topImage[0].name[vm.$session.get('lang')]
        }

        if (typeof top_home_web !== "undefined") {
          topMobileHeader.classList.remove('imgLoadingTopHome', 'h-230')
          topHeader.classList.remove('imgLoadingTopHome', 'h-400')
          if (window.matchMedia('(max-width: 768px)').matches) {
            topMobileHeader.style.backgroundImage = `url('${data.top_home_web[0].image.mobile}')`
            topMobileHeader.style.backgroundSize = '100%'
            topMobileHeader.style.backgroundPosition = 'top'
            topMobileHeader.style.backgroundRepeat = 'no-repeat'
            topMobileHeader.style.height = '230px'
            topMobileHeader.style.cursor = 'pointer'
            if (data.top_home_web[0].url && data.top_home_web[0].url.mobile) {
              topMobileHeader.addEventListener('click', () => {
                window.location = data.top_home_web[0].url.mobile
              })
            }
          } else {
            topHeader.style.backgroundImage = `url('${top_home_web[0].image.desktop}')`
            topHeader.style.backgroundSize = 'cover'
            topHeader.style.cursor = 'pointer'
            if (data.top_home_web[0].url && data.top_home_web[0].url.desktop) {
              topHeader.addEventListener('click', () => {
                window.location = data.top_home_web[0].url.desktop
              })
            }
          }
        } else {
          topMobileHeader.classList.remove('imgLoadingTopHome', 'h-230')
          topHeader.classList.remove('imgLoadingTopHome', 'h-400')
        }

        let h = 0
        let w = 0
        let layer = {
          'modules': [],
          'assets': {
            'products': [],
            'promotions': [
              {
                'id': 'all-home-1',
                'name': 'view-all-deals',
                'creative': {
                  'id': 'all-home-1-creative',
                  'type': 'internal'
                },
                'attributes': {
                  'size': w + 'x' + h,
                  'destination': window.location.origin + '/order'
                }
              }
            ]
          }
        }
        let pop = {
          'id': 'pop-home',
          'name': 'most-popular-deals',
          'type': 'merchandising',
          'placement': 'home-promo-slots',
          'items': []
        }
        let prods = []
        if (vm.left.hasOwnProperty('name')) {
          let lname = vm.left.name.split(' ').join('-')
          pop.items.push({
            'id': lname,
            'type': 'product',
            'position': '1'
          })
          prods.push({
            'id': lname,
            'name': lname,
            'category': 'deal',
            'variants': [],
            'value': {},
            'tax': {
              'type': '',
              'name': '',
              'size': '0'
            },
            'purchaseMethod': 'main'
          })
        }
        if (vm.right.hasOwnProperty('name')) {
          let rname = vm.right.name.split(' ').join('-')
          pop.items.push({
            'id': rname,
            'type': 'product',
            'position': '2'
          })
          prods.push({
            'id': rname,
            'name': rname,
            'category': 'deal',
            'variants': [],
            'value': {
              'displayGross': '0',
              'displayTax': '0'
            },
            'tax': {
              'type': '',
              'name': '',
              'size': '0'
            },
            'purchaseMethod': 'main'
          })
        }
        layer.assets.products = prods
        layer.modules.push(pop)
        layer.modules.push({
          'id': 'all-home',
          'name': 'all-deals',
          'type': 'promotions',
          'placement': 'home-promo-bottom',
          'items': [
            {
              'id': 'all-home-1',
              'type': 'promotion',
              'position': '1'
            }
          ]
        })
        vm.$root.$emit('onTrackingHomepage', layer)
      }, error => {
        console.log('error', error)
        topHeader.classList.remove('imgLoadingTopHome', 'h-400')
        topMobileHeader.classList.remove('imgLoadingTopHome', 'h-230')
        leftHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
        leftHomeBanner.style.width = '0px'
        rightHomeBanner.classList.remove('imgLoadingTopHome', 'h-185')
        rightHomeBanner.style.width = '0px'
        bannerMidBottom.classList.remove('imgLoadingTopHome', 'h-110')
      })
    }
  }
}

</script>
<style scoped>
  .pt-210 {
    padding-top: 210px !important;
  }

  .pt-120 {
    padding-top: 120px !important;
  }
  @media (max-width: 800px) {
    #cpn-home-popular .xs-mb-0{
      margin-bottom: 0;
    }
    #cpn-home-popular .xs-position-relative{
      position: relative;
      z-index: 99;
    }

    #cpn-home-popular .xs-pt-5{
      padding-top: 5px;
    }

    #cpn-home-popular .xs-pb-0{
      padding-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomePopularDeal.vue